export const BLUE_100 = '#0072BB';
export const BLUE_200 = '#1C2C57';
export const GRAY_100 = '#E7E7E7';
export const GRAY_200 = '#373737';
export const GRAY_300 = '#282828';
